import {ILanguageTokens, LanguageTokens} from "../../localization/LanguageTokens";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import loadFromLocalStorage from "../../util/storage/json/loadFromLocalStorage";
import saveToLocalStorage from "../../util/storage/json/saveToLocalStorage";
import {APP_TOKEN} from "../../Config";

export const LANGUAGE_TOKENS = ['EN', 'DE'];
export type LANGUAGE_TOKEN = 'EN' | 'DE';
const LANGUAGE_STATE_TOKEN = `${APP_TOKEN}LANGUAGE_STATE_TOKEN`;

export interface ILanguageState {
    languageToken: LANGUAGE_TOKEN;
    availableLanguageTokens: LANGUAGE_TOKEN[];
    languageTokens: ILanguageTokens;
}

const initialState: ILanguageState = {
    languageToken: 'EN',
    availableLanguageTokens: [
        "EN",
        "DE",
    ],
    languageTokens: LanguageTokens._props['EN'],
};

const loadedState: ILanguageState = loadFromLocalStorage(LANGUAGE_STATE_TOKEN, {...initialState});

export const languageSlice = createSlice({
    name: 'language',
    initialState: loadedState,
    reducers: {
        setLanguage: (state: ILanguageState, action: PayloadAction<LANGUAGE_TOKEN>) => {
            const languageToken = action.payload;

            const updatedState = {
                ...state,
                languageToken,
                languageTokens: LanguageTokens._props[languageToken],
            };
            LanguageTokens.setLanguage(languageToken);
            saveToLocalStorage(LANGUAGE_STATE_TOKEN, updatedState);

            return updatedState;
        },
    },
});

export const {setLanguage} = languageSlice.actions;
